module.exports = __webpack_public_path__ + "static/media/success.ec2d641f.mp3";